import { render, staticRenderFns } from "./typeTable.vue?vue&type=template&id=68cd096a&scoped=true"
import script from "./typeTable.vue?vue&type=script&lang=js"
export * from "./typeTable.vue?vue&type=script&lang=js"
import style0 from "./typeTable.vue?vue&type=style&index=0&id=68cd096a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd096a",
  null
  
)

export default component.exports